<template lang="pug">
  form.feature-update(@submit.prevent="updateBoard")
    .form-field
      .form-field-with-label(:class="{ disabled: feature.isReadOnly }")
        label
          h6 Merge Into
          .merge-search
            input(type="text", placeholder="Search", v-debounce="search", v-model="filters.text", :disabled="feature.isReadOnly")
            .merge-search-results(v-if="showResults")
              .item(v-for="result in results", @click="mergeFeature(result)")
                .feature
                  .feature-name
                    h5 {{ result.name }}
                  .feature-stats
                    .feature-stat
                      font-awesome-icon.icon(:icon="['fas','caret-up']")
                      span {{ result.stats.likes }}
                    .feature-stat
                      font-awesome-icon.icon(:icon="['fad','comments']")
                      span {{ result.stats.comments }}
            .no-search-results(v-if="noResults")
              p No Results


</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'FeatureMerge',
  components: {
  },
  props: {
    board: Object
  },
  data () {
    return {
      filters: {
        text: ''
      },
      results: []
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features.selected
    }),
    showResults () {
      return this.filters.text.length > 0 && this.results.length > 0
    },
    noResults () {
      return this.filters.text.length > 0 && this.results.length === 0      
    }
  },
  methods: {
    search () {
      let filter = {
        text: this.filters.text,
        board: [ this.board._id ]
      }
      let sort = {
        prop: 'popular'
      }
      this.$axios.post(`feature/search`, { filter, sort })
        .then(result => {
          //console.log(result)
          this.results = result.data.filter(f => f._id !== this.feature._id)
        })

      //console.log(filter)
    },
    mergeFeature (feature) {
      console.log(feature)
      this.$DialogBox.open({
        parent: this,
        open: true,
        header: `Merge into "${feature.name}"?`,
        message: 'This feature will be archived and set to readonly.',
        onConfirm: () => {
          this.$store.dispatch('features/mergeFeature', {
            slug: this.feature.slug,
            update: {
              link: feature._id
            }
          })
          .then(() => {
            this.$router.push({
              name: 'AdminFeature',
              params: {
                boardSlug: this.board.slug,
                featureSlug: feature.slug
              }
            })
          })
        }
      })

    }
  }
}
</script>

<style scoped lang="stylus">
.form-field-with-label
  padding 0
  h6
    padding $spacing $spacing 0 $spacing
.merge-search
  position relative
  input[type="text"]
    padding 0 $spacing $spacing $spacing
  .merge-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    position absolute
    margin-top 5px
    //height 100px
    width 100%
    z-index 100
    .item
      border-bottom $border-default
      padding $spacing
      &:last-child
        border-bottom none
  .no-search-results
    background-color #fff
    border $border-default
    border-radius $border-radius
    box-shadow 0 6px 12px rgba(0,0,0,0.175)
    padding $spacing
    position absolute
    margin-top 5px
    //height 100px
    text-align center
    width 100%
    z-index 100
        
  .feature-name
    margin-bottom 5px
  .feature-stats
    font-size $text-size-smaller
    display flex
    .feature-stat
      //border $border-default
      margin-right $spacing
      //padding 2px
      .icon
        margin-right 5px
</style>
